<template>
  <div id="settings-list"
       class="flex flex-col flex-1 min-h-0 pt-2 overflow-hidden"
  >
    <side-list :items="items"
               :selected-id="selectedLabel"
               id-key="label"
               class="h-full min-h-0"
    >
      <template #item="{ item, isItemSelected }">
        <settings-list-item :is-selected="isItemSelected"
                            :label="item.label"
                            :url="item.url"
                            :route="item.route"
                            :icon="item.icon"
        />
      </template>
    </side-list>
  </div>
</template>

<script>
import SettingsListItem from '@/components/settings/SettingsListItem.vue'
import SideList from '@/components/common/SideList.vue'
import { ROUTE_NAMES } from '@/router'

const SETTINGS_ROUTE_ALIASES = {
  [ROUTE_NAMES.botsWithChannel]: ROUTE_NAMES.bots,
  [ROUTE_NAMES.integrationsWithChannel]: ROUTE_NAMES.integrations
}

function buildSettingsNavItems() {
  return [
    { label: 'Bots', route: ROUTE_NAMES.bots, icon: 'bot-icon' },
    { label: 'Markets', route: ROUTE_NAMES.markets, icon: 'markets-icon' },
    { label: 'Chat Themes', route: ROUTE_NAMES.botTheme, icon: 'theme-icon' },
    { label: 'Knowledge Bases', route: ROUTE_NAMES.knowledgeBases, icon: 'GPT-icon' },
    { label: 'Variables', route: ROUTE_NAMES.variables, icon: 'variables-icon' },
    { label: 'Integrations', route: ROUTE_NAMES.integrations, icon: 'integrations-icon' },
    { label: 'Channels', url: process.env.VUE_APP_AMIO_MESSAGING_APP_URL, icon: 'channels-icon' },
    { label: 'Billing', url: process.env.VUE_APP_STRIPE_BILLING_URL, icon: 'billing-icon' },
    { label: 'Users', url: process.env.VUE_APP_USERS_URL, icon: 'users-icon' },
    { label: 'Logout', route: ROUTE_NAMES.logout, icon: 'logout-icon' }
  ]
}

export function getSettingsSectionTitle(routeName) {
  const resolvedRoute = SETTINGS_ROUTE_ALIASES[routeName] || routeName
  const item = buildSettingsNavItems().find(item => item.route === resolvedRoute)
  return item ? item.label : 'Bots'
}

export default {
  name: 'SettingsList',

  components: { SideList, SettingsListItem },

  computed: {
    selectedLabel() {
      return getSettingsSectionTitle(this.$route.name)
    },
    items() {
      return buildSettingsNavItems()
    }
  }
}
</script>

<style lang="scss">
#settings-list {
  .vb-dragger {
    @apply hidden invisible;
  }

  @apply p-1 pb-4;

  .side-list {
    @apply pb-2;
  }

  .side-list ul {
    @apply pb-8;
  }

  a {
    @apply text-gray-dark;
  }
}
</style>
